jQuery_T4NT(document).ready(function($) {
  // any code js
  var w_width = $(window).width();
  var video_height = w_width / 0.8;
  console.log( w_width )
  if ( w_width < 767 )
  {
    $('.right_slider.').css('height', video_height);
  }

  const medias = document.querySelectorAll('.t4-product-media');
   //console.log(medias)
  if(medias.length) {
    medias.forEach(function(media) {
      //console.log(media.innerHTML)
      if($(media).children().length == 0) {
        $(media).hide()
      }
    })
  }
});